/**
 * @file index.tsx
 *
 * @fileoverview Pager component. Renders a list of links as a pager.
 */

import * as React from "react";
import styles from "./Pager.module.scss";

export interface PagerProps {
  /**
   * The contents of the pager.
   */
  children: React.ReactNode | string;
}

/**
 * Styles a list of items (anchors inside a list) with the theme provided by the theme object, in the form of a pager.
 */
export default function Pager({ children, ...props }: PagerProps) {
  return (
    <nav role="navigation">
      <ul className={styles.pager} {...props}>
        {children}
      </ul>
    </nav>
  );
}
export { Pager };
